import { render } from "./d-header.vue?vue&type=template&id=39e74bfe&scoped=true&ts=true"
import script from "./d-header.vue?vue&type=script&lang=ts"
export * from "./d-header.vue?vue&type=script&lang=ts"

import "./d-header.vue?vue&type=style&index=0&id=39e74bfe&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e74bfe"]])

export default __exports__